import { SELECT_STATES as c } from "./index.es69.js";
const a = "__internalVersion";
function p(n) {
  return n.hasOwnProperty(a);
}
function f(n) {
  p(n) ? n[a]++ : Object.defineProperty(n, a, {
    value: 0,
    writable: !0,
    enumerable: !1
  });
}
function V(n) {
  if (p(n))
    return n[a];
}
function L(n) {
  return V(n) === void 0;
}
function i(n) {
  return Array.isArray(n.children) && n.children.length > 0;
}
function k(n) {
  return !i(n);
}
function S(n, t) {
  n.forEach((e, l) => {
    if (e.selfIndex = l, t && (e.parents = t), e.children) {
      const r = t ? t.slice(0) : [];
      r.push(e.selfIndex), S(e.children, r);
    }
  });
}
function h(n, t) {
  if (n.parents === void 0)
    return;
  let e = {
    children: t
  };
  for (const l of n.parents)
    if (e.children)
      e = e.children[l];
    else {
      console.error("tried to get a parent from an invalid breadcrumbs", n);
      break;
    }
  return e;
}
function I(n, t) {
  const e = {
    ...n,
    selected: t,
    isSelected: t !== c.unselected
  };
  if (i(e)) {
    const l = [];
    e.children.forEach((r) => {
      const s = I(r, t);
      l.push(s);
    }), e.children = l;
  }
  return e;
}
function w(n, t) {
  n.selected = t, n.isSelected = t !== c.unselected, i(n) && n.children.forEach((e) => {
    w(e, t);
  });
}
function v(n) {
  let t = n.selected;
  if (i(n)) {
    const e = {
      selected: 0,
      unselected: 0,
      indeterminate: 0
    };
    n.children.forEach((l) => {
      l.selected === c.selected ? e.selected += 1 : l.selected === c.unselected ? e.unselected += 1 : e.indeterminate += 1;
    }), e.selected === n.children.length ? t = c.selected : e.unselected === n.children.length ? t = c.unselected : t = c.indeterminate;
  }
  n.selected = t, n.isSelected = t !== c.unselected;
}
function b(n, t, e = !1) {
  const l = h(n, t);
  if (l === void 0)
    return n;
  const r = {
    ...l,
    children: l.children.slice(0)
  };
  return r.children[n.selfIndex] = n, e && v(r), b(r, t, e);
}
function j(n, t, e = !1) {
  t((l) => {
    const r = b(n, l, e), s = l.slice(0);
    return s[r.selfIndex] = r, f(s), s;
  });
}
function y(n) {
  return n.map((t) => {
    const e = {
      ...t,
      selected: c.unselected,
      isSelected: !1
    };
    return i(e) && (e.children = y(e.children)), e;
  });
}
function D(n, t) {
  t((e) => {
    const l = y(e), r = C(l, n);
    return f(r), r;
  });
}
function C(n, t) {
  return n.map((e) => {
    if (e.value === t.value)
      return {
        ...e,
        selected: c.selected,
        isSelected: !0
      };
    if (i(e)) {
      const l = C(e.children, t), r = l.some((s) => s.isSelected);
      return {
        ...e,
        children: l,
        selected: r || e.value === t.value ? c.selected : c.unselected,
        isSelected: r || e.value === t.value
      };
    }
    return e;
  });
}
function T(n, t = "child") {
  n((e) => {
    const l = g(e, t);
    return f(l), l;
  });
}
function g(n, t = "child") {
  let e = !1;
  return n.map((l) => {
    if (t === "child" ? !i(l) && l.isSelected && !e : l.isSelected && !e)
      return e = !0, l;
    let s = {
      ...l,
      isSelected: !1,
      selected: c.unselected
    };
    if (i(l)) {
      const d = g(l.children, t);
      d.some((o) => o.isSelected) ? s = {
        ...l,
        children: d,
        isSelected: !0,
        selected: c.selected
      } : s.children = d;
    }
    return s;
  });
}
function _(n, t, e) {
  if (n.selected === e) return n.selected;
  let l = c.unselected;
  n.selected === c.unselected && (l = c.selected), e !== void 0 && (l = e);
  const r = I(n, l);
  return j(r, t, !0), l;
}
function A(n, t = /* @__PURE__ */ new Map()) {
  return n.forEach((e) => {
    i(e) ? A(e.children, t) : t.set(e.value, e);
  }), t;
}
function E(n, t) {
  const e = { ...n, isHidden: !1 };
  if (t) {
    const l = Object.keys(t);
    for (const r of l) {
      const s = t[r];
      let d = e[r];
      if (typeof d == "object" && (d = String(d)), s instanceof RegExp)
        String(d).match(s) == null && (e.isHidden = !0);
      else if (typeof s == "string") {
        const u = String(d).toLowerCase(), o = s.toLowerCase();
        u.includes(o) || (e.isHidden = !0);
      } else
        d !== s && (e.isHidden = !0);
      if (e.isHidden === !0)
        break;
    }
  }
  if (i(e)) {
    const l = [];
    e.children.forEach((r) => {
      const s = E(r, t);
      l.push(s);
    }), e.children = l;
  }
  return e;
}
function x(n) {
  n && n.forEach((t) => {
    t.isHidden = !1, x(t.children);
  });
}
function O(n) {
  n && n.forEach((t) => {
    var e;
    t.isHidden || x(t.children), O(t.children), (e = t.children) != null && e.find((l) => !l.isHidden) && (t.isHidden = !1);
  });
}
function F(n, t) {
  const e = [];
  return n.forEach((l) => {
    const r = E(l, t);
    e.push(r);
  }), O(e), f(e), e;
}
function K(n, t) {
  n((e) => F(e, t));
}
function H(n) {
  var t;
  return {
    ...n,
    childrenExpanded: !0,
    children: (t = n.children) == null ? void 0 : t.map((e) => H(e))
  };
}
function M(n) {
  n((t) => {
    const e = t.map((l) => l.isHidden ? l : H(l));
    return f(e), e;
  });
}
function P(n, t) {
  t || (t = n), t.forEach((e) => {
    if (e.selected === c.selected) {
      w(e, c.selected);
      let l = h(e, n);
      for (; l; )
        v(l), l = h(l, n);
    }
    i(e) && P(n, e.children);
  });
}
function R(n, t) {
  if (L(n)) {
    const e = n.slice(0);
    S(e), P(e), f(e), t(e);
  }
}
const $ = (n, t = "child") => {
  if (t === "child") {
    const e = A(n), r = Array.from(e.values()).find((s) => s.isSelected);
    return r != null && r.label ? `${r == null ? void 0 : r.label}` : "Select";
  } else {
    let e, l = -1;
    const r = (s, d = 0) => {
      for (const u of s) {
        if (u.isSelected) {
          const o = k(u) ? d + 1e3 : d;
          o > l && (e = u, l = o);
        }
        i(u) && r(u.children, d + 1);
      }
    };
    return r(n), e != null && e.label ? `${e.label}` : "Select";
  }
}, B = (n) => {
  let t = n.every(({ selected: e }) => e === c.selected) ? c.selected : c.unselected;
  return t !== c.selected && n.some(({ selected: e }) => e !== c.unselected) && (t = c.indeterminate), t;
};
export {
  S as buildParentsTree,
  f as bumpObjectInternalVersion,
  B as calculateSelectionStateByChildren,
  P as calculateSelections,
  M as expandVisibleItems,
  K as filterItems,
  A as getAllLeaves,
  F as getFilteredItems,
  $ as getSelectedItemLabel,
  i as isInternalNode,
  L as isInternalVersionReset,
  k as isLeaf,
  R as parseNewItemsObject,
  T as selectOnlyFirstLeafItem,
  D as selectSingleItem,
  j as setMutatedItem,
  _ as toggleSelectItem
};
//# sourceMappingURL=index.es70.js.map
